function handleDiscount() {
    document.getElementById('overlay').style.display = 'block';
    document.getElementById('overlay-content').style.display = 'flex';
    document.body.style.overflow = 'hidden'; //disable scrolling
    // alert("test")
  }

  async function closeOverlay() {
    document.getElementById('overlay').style.display = 'none';
    document.getElementById('overlay-content').style.display = 'none';
    document.body.style.overflow = 'auto'; // Enable scrolling
  }

  let currentlyAppliedButton = null; // Variable to track the previously applied button

  function onDiscountApplied(event) {
    const button = event.target; // Get the clicked button
    const discountCode = button.value; // Retrieve the discount code from the button's value

    // Parse cookies to check for the existing discount code
    const isCodeApplied = document.cookie
      .split('; ')
      .some((cookie) => cookie.startsWith(`discount_code=${discountCode}`));

    if (isCodeApplied) {
      // Code is already applied; no action needed
      button.disabled = true;
      button.innerText = 'Applied';
    } else {
      // Remove the previous discount code and re-enable the button
      if (currentlyAppliedButton && currentlyAppliedButton !== button) {
        currentlyAppliedButton.disabled = false; // Re-enable the previous button
        currentlyAppliedButton.innerText = 'Apply'; // Reset the previous button text
      }

      // Apply the new discount code
      fetch(`/discount/${discountCode}`);
      document.cookie = `discount_code=${discountCode}; path=/; max-age=0`; // Set new cookie for 1 day

      // Disable the clicked button and update its text
      button.disabled = true;
      button.innerText = 'Applied';

      // Update the tracker for the currently applied button
      currentlyAppliedButton = button;
    }
  }

  // Function to initialize buttons on page load
  function initializeDiscountButtons() {
    const buttons = document.querySelectorAll('.product-form__submit.button--small');

    // Get the currently applied discount code from cookies
    const appliedCode = document.cookie
      .split('; ')
      .find((cookie) => cookie.startsWith('discount_code='))
      ?.split('=')[1]; // Extract the code value from the cookie

    // Iterate over all buttons and check if they match the applied code
    buttons.forEach((button) => {
      if (button.value === appliedCode) {
        button.disabled = true; // Disable the button
        button.innerText = 'Applied'; // Change button text
        currentlyAppliedButton = button; // Track the applied button
      } else {
        button.disabled = false; // Ensure other buttons are enabled
        button.innerText = 'Apply'; // Reset other button texts
      }
    });
  }

  // Run the initialization on page load
  document.addEventListener('DOMContentLoaded', initializeDiscountButtons);
